export enum PreferredTermType {
    FivePlusTwo = 0,
    TenPlusTwo = 1,
    FifteenPlusTwo = 2,
    SixPlusSix = 3,
    NinePlusSix = 4,
    Thirty = 5,
}
